import {Injectable} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {VenueContactData} from "./venue-contact.data";
import {firstValueFrom} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class VenueContactService {
    constructor(private auth: AuthApiService, private http: HttpClient) {
    }

    async getVenueContact(venueId: string): Promise<VenueContactData> {
        return firstValueFrom(this.http.get<VenueContactData>("/fonzie/customer-instance-venue/" + venueId + "/venue-contacts/primary", {headers: this.auth.getHttpHeaderOptions()}));
    }

    async createVenueContact(venueId: string, contact: VenueContactData): Promise<VenueContactData> {
        return firstValueFrom(this.http.post<VenueContactData>("/fonzie/customer-instance-venue/" + venueId + "/venue-contacts", contact, {headers: this.auth.getHttpHeaderOptions()}));
    }

}
